import { Injectable } from '@angular/core';
import { ProductSummary } from '@core/models/product-summary.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface ProductSummaryState extends EntityState<ProductSummary> {}

export function createInitialState(): ProductSummaryState {
  return null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'productSummary', resettable: true })
export class ProductSummaryStore extends EntityStore<ProductSummaryState> {
  constructor() {
    super(createInitialState());
  }
}
